<!--<app-tree *ngIf="configSvc.currentConfigValue.debug"></app-tree>
<app-entity-selector *ngIf="configSvc.currentConfigValue.debug"></app-entity-selector>-->
<div class="container-head">
  <div *ngIf="user.profileId !== 2 && user.roleId !== 4" class="action_pb btn btn-dark btn-refresh">
    <div class="action_reassign" (click)="refresh()">
      <div class="action_reassign_icon"></div>
    </div>
  </div>
  <!--<div>
    <button type="button" class="btn btn-outline-secondary me-2" (click)="downloadCsv()"><i class="bi bi-download"></i>
      {{'MIMESYS.DOWNLOAD_CSV' | translate }}</button>
  </div>-->
  <div>
    <button type="button" class="btn btn-outline-secondary me-2" (click)="downloadPackagesCsv()"><i
        class="bi bi-download"></i>
      {{'MIMESYS.DOWNLOAD_CSV' | translate }}</button>
  </div>
  <div *ngIf="user.roleId !== 4 && (user.profileId === 1 || user.profileId === 3)" class="action_pb btn btn-dark"
    [ngClass]="{'only-reassign':user.roleId !== 1}" data-bs-toggle="modal" [attr.data-bs-target]="'#reassignModal'">
    <div class="action_reassign">
      <div class="action_reassign_icon"></div>
    </div>
    <div class="action_rot" *ngIf="action === 'reassign'"><span>{{ 'COMMON.REASSIGN_PACKAGE' | translate }}</span></div>
  </div>
  <div *ngIf="user.roleId === 1 && (user.profileId === 1 || user.profileId === 3)" class="action_pb btn btn-dark"
    [routerLink]="'/licenses/packages/create/'" style="cursor:pointer;">
    <div class="action_new">
      <div class="action_new_icon"></div>
    </div>
    <div class="action_rot">
      <span>{{ 'COMMON.NEW_PACKAGE' | translate }}</span>
    </div>
  </div>
  <div *ngIf="user.roleId === 1 && configSvc.currentConfigValue.debug" class="action_pb btn btn-dark">
    <div class="action_new">
      <div class="action_new_icon"></div>
    </div>
    <!--<div class="action_rot" [routerLink]="'/licenses/package/create'">
      <span>{{ 'COMMON.NEW_PACKAGE' | translate }}</span>
    </div>-->
    <div>
      <a [routerLink]="'/devices/create/'" class="btn btn-dark"><span>{{ 'COMMON.NEW_DEVICE' | translate
          }}</span></a>
    </div>
  </div>
</div>
<div>
  <hbo-datatable-smart *ngIf="packages$ | async as packages" [columns]="columns" [typeData]="'package'"
    [entities_filter]="entities_filter" [package_types_filter]="packageTypes" [status_filter]="packageStatus"
    [category_filter]="category_filter" [items]="packages" (reload)="searchPackages($event)"
    [showFilterPanel]="true" [showPackageFilters]="true" [showTeamFilter]="true" [teams_filter]="teams">
    <tbody class="table-group-divider accordion" id="accordionPackage">
      <ng-container *ngFor="let package of packages.data">
        <tr>
          <th scope="row">
            <div style="height: 32.5px;"></div>
          </th>
          <td>{{ package.id }}</td>
          <td *ngIf="user.roleId === 1" [innerHTML]="package.assignedEntityId ? getName('dist',
          package.owner?.id!,package.assignedEntityId) : '...' "></td>
          <td *ngIf="user.roleId <= 2" [innerHTML]="package.assignedEntityId ?
          getName('head',package.owner?.id!,package.assignedEntityId) : '...' "></td>
          <td>
            <span *ngIf="!([2, 3].includes(package.packageStatusId) && package.assigned?.isBase && user.roleId !== 4 && (user.profileId === 3 || user.profileId === 1))
                      && !(package.packageStatusId === 1 && package.assigned?.entityTypeId !== 4 && user.roleId !== 4 && (user.profileId === 3 || user.profileId === 1))"
              [innerHTML]="package.assignedEntityId ? getName('shop',package.assignedEntityId): '...' "></span>
            <span class="badge rounded-pill border border-success text-success cursor-pointer badge-button-hover"
              *ngIf="[2, 3].includes(package.packageStatusId) && package.assigned?.isBase && user.roleId !== 4 && (user.profileId === 3 || user.profileId === 1)"
              (click)="noDevicePackageToReassign = package"
              data-bs-toggle="modal"
              data-bs-target="#noDeviceReassignModal">
              {{ 'PACKAGES.ASSIGN_PACKAGE' | translate }}
            </span>
            <!-- Package still parked at a head office/distributor: assign it down to an optical shop -->
            <span class="badge rounded-pill border border-success text-success cursor-pointer badge-button-hover"
              *ngIf="package.packageStatusId === 1 && package.assigned?.entityTypeId !== 4 && user.roleId !== 4 && (user.profileId === 3 || user.profileId === 1)"
              (click)="packageToAssign = package"
              data-bs-toggle="modal"
              data-bs-target="#reassignModal-assign">
              {{ 'PACKAGES.ASSIGN_PACKAGE' | translate }}
            </span>
          </td>
          <td>{{ package.packageType.name }}</td>
          <td><span [className]="package.packageCategoryId ===2 ? 'badge text-bg-warning rounded-pill' :''">{{
              ('LICENSE.' + (package.category.name | uppercase )) |translate }}</span></td>
          <td>
            <span class="badge rounded-pill text-bg-secondary" *ngIf="package.packageStatusId === 1">{{
              'LICENSE.ASSIGNED'
              | translate }}</span>
            <span class="badge rounded-pill text-bg-warning" *ngIf="package.packageStatusId === 2"><span>{{
                'LICENSE.TEST'|translate}}</span>
              <!--<i class="bi bi-exclamation-circle-fill" *ngIf="user.roleId ==1 && package.packageOriginId"></i>-->
              <span *ngIf="package.packageOriginId" class="package-upgrade-arrow-ref"
                [ngClass]="{ 'package-upgrade-arrow-ref-right': package.packageOriginId && package.packageUpgradeId }"
                [routerLink]="package.packageOriginId != 1 ? '/licenses/packages/edit/'+package.packageOriginId : undefined"
                [title]="package.packageOriginId != 1 ? package.packageOriginId : ''">↓</span></span>
            <span class="badge rounded-pill text-bg-success"
              *ngIf="package.packageStatusId === 3"><span>{{'LICENSE.ACTIVE' |translate}}</span>
              <!--<i class="bi bi-exclamation-circle-fill" *ngIf="user.roleId ==1 && package.packageOriginId"></i>-->
              <span *ngIf="package.packageOriginId" class="package-upgradef-arrow-ref"
                [ngClass]="{ 'package-upgrade-arrow-ref-right': package.packageOriginId && package.packageUpgradeId }"
                [routerLink]="package.packageOriginId != 1 ? '/licenses/packages/edit/'+package.packageOriginId : undefined"
                [title]="package.packageOriginId != 1 ? package.packageOriginId : ''">↓</span></span>
            <span class="badge rounded-pill text-bg-danger" *ngIf="package.packageStatusId === 4"><span>{{
                'LICENSE.INACTIVE_REQUEST' | translate }}</span><span *ngIf="package.packageOriginId"
                class="package-upgrade-arrow-ref"
                [ngClass]="{ 'package-upgrade-arrow-ref-right': package.packageOriginId && package.packageUpgradeId }"
                [routerLink]="package.packageOriginId != 1 ? '/licenses/packages/edit/'+package.packageOriginId : undefined"
                [title]="package.packageOriginId != 1 ? package.packageOriginId : ''">↓</span></span>
            <span class="badge rounded-pill text-bg-secondary" *ngIf="package.packageStatusId === 5">
              {{ 'LICENSE.INACTIVE'| translate }}
              <i class="bi bi-exclamation-circle-fill"
                *ngIf="package.upgradedAt && ((invoiceable(package) || user.roleId != 4 ) && package.renewalPersDate) && (package.packageUpgradeId || (!package.packageUpgradeId && package.packageStatusId !==5))"
                [ngClass]="{'package-billed-no-licenses':(!package.licenses.length && package.packageUpgradeStatus?.packageStatusId !== 6 && package.packageUpgradeId) || (user.roleId !== 1 && package.licenses.length && package.packageUpgradeStatus?.packageStatusId !== 6 && package.packageUpgradeId), 'package-billed':package.licenses.length && package.packageUpgradeStatus?.packageStatusId !== 6 && package.packageUpgradeId,'package-recoverable':package.packageUpgradeStatus?.packageStatusId === 6 && !invoiceable(package),'package-upgrade-ref':invoiceable(package)}"></i>
              <span *ngIf="package.packageOriginId" class="package-upgrade-arrow-ref"
                [ngClass]="{ 'package-upgrade-arrow-ref-left': package.packageOriginId && package.packageUpgradeId }"
                [routerLink]="package.packageOriginId != 1 ? '/licenses/packages/edit/'+package.packageOriginId : undefined"
                [title]="package.packageOriginId != 1 ? package.packageOriginId : ''">↓</span>
              <span *ngIf="package.packageUpgradeId" class="package-upgrade-arrow-ref"
                [ngClass]="{ 'package-upgrade-arrow-ref-right': package.packageOriginId && package.packageUpgradeId }"
                [routerLink]="package.packageOriginId != 1 ? '/licenses/packages/edit/'+package.packageUpgradeId : undefined"
                [title]="package.packageUpgradeId">↑</span>
            </span>
            <span class="badge rounded-pill text-bg-warning" *ngIf="package.packageStatusId === 6">
              {{ 'LICENSE.IN_UPGRADE'| translate }}
              <i class="bi bi-exclamation-circle-fill package-upgrade-ref"
                *ngIf="package.packageOriginId && inheritedLicensesInvoiceable(package)"></i>
              <span class="package-upgrade-arrow-ref"
                [ngClass]="{ 'package-upgrade-arrow-ref-right': package.packageOriginId && package.packageUpgradeId }"
                [routerLink]="package.packageOriginId != 1 ? '/licenses/packages/edit/'+package.packageOriginId : undefined"
                [title]="package.packageOriginId != 1 ? package.packageOriginId : ''">↓</span>
            </span>
          </td>
          <td *ngIf="user.roleId === 1">{{package.assignedAt | date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd
            HH:mm':'yyyy/MM/dd' ) }}</td>
          <td>{{package.packageCategoryId === 1 ? (package.remainingTestDays ?? package.testDays) : '-'}}<span
              class="package-test-days">{{ package.packageCategoryId === 1 ? ('/'+package.testDays):'-'}}</span></td>
          <!--<td>{{package.packageCategoryId === 1 ? package.renewalDate ? package.renewalDate : (setPackageLabelDate(package,'renewalDate') | date:'yyyy/MM/dd HH:mm') :''}}</td>-->
          <td>{{(package.packageCategoryId === 1 ? (package.renewalInvoiceableDate!|
            date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd HH:mm':'yyyy/MM/dd' )) :'-') ??
            '-'}}</td>
          <td *ngIf="configSvc.currentConfigValue.debug && user.roleId === 1" class="period-td">
            {{package.packageCategoryId === 1 ? ((package.packagePeriodId
            === 1 ? 'LICENSE.MONTHLY' : 'LICENSE.ANNUAL')|translate ) : '-'}}</td>
          <td *ngIf="user.roleId !== 4">
            <div *ngIf="!package.deviceId">-</div>
            <div *ngIf="package.deviceId" class="device-link-td" [title]="package.deviceId"><i class="bi bi-link"></i>
            </div>
          </td>
          <!-- include actions
        <td *ngIf="user.roleId === 1"><i class="bi bi-trash"
            [ngClass]="{'bi-trash-disabled':package.deviceId || ( package.packageStatusId === 6 || (package.packageUpgradeId && package.packageStatusId === 5 && invoiceable(package)))}"
            (click)="selectedPackage(package.id)" data-bs-toggle="modal"
            [attr.data-bs-target]="'#confirmationModal-'+modalConfirm"></i></td>
            -->
          <td><a [routerLink]="'/licenses/packages/edit/' + package.id" class="link-dark link-underline-opacity-0">View
              Details <i class="bi bi-chevron-right"></i></a></td>
        </tr>
      </ng-container>
      <tr *ngIf="!packages.data.length">
        <td [attr.colspan]="columns.length + 1" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
      </tr>
    </tbody>
  </hbo-datatable-smart>
</div>
<hbo-reassign-modal (confirm)="reassign($event)" [package_types_filter]="packageTypes" [entity]="entity"
  (modalsCrossData)="setLicenseData($event)" [action]="'reassign'"></hbo-reassign-modal>

<!-- Second instance so the inline per-package flow never shares state with the toolbar one -->
<hbo-reassign-modal [id]="'assign'" [presetPackage]="packageToAssign" (confirm)="reassign($event)"
  [package_types_filter]="packageTypes" [entity]="entity" (modalsCrossData)="setLicenseData($event)"
  (closed)="packageToAssign = null" [action]="'reassign'"></hbo-reassign-modal>

<hbo-no-device-reassign-modal
  [package]="noDevicePackageToReassign"
  (confirmed)="onNoDeviceReassignConfirmed()"></hbo-no-device-reassign-modal>
<hbo-confirmation-modal [id]="modalConfirm" (confirm)="delete()"></hbo-confirmation-modal>
<hbo-confirmation-modal [id]="'some-license-inactive'" [hideConfirm]="true" (confirm)="show($event)"
  [head]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP'" [head5]="'('+licenseInactiveData+')'"
  [extendedMessage]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_EXTENDED'" [message]="'COMMON.EMPTY_STRING'"
  [cancelText]="'COMMON.UNDERSTAND'"></hbo-confirmation-modal>

<hbo-confirmation-modal [id]="'admin-some-license'" [hideConfirm]="true"
  (confirm)="backConfirmReassignPackageModal($event)" [head]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP'"
  [message]="licenseWarningNoDevice ? 'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_ADMIN_NO_DEVICE' : 'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_ADMIN'"
  [cancelText]="'COMMON.UNDERSTAND'"></hbo-confirmation-modal>

<!-- The inline assign flow raises its own copies: the reassign modal suffixes these ids per instance,
  so each one bounces back to the modal that was actually open. Handlers are shared, they already
  resolve the active instance through activeReassignModal. -->
<hbo-confirmation-modal [id]="'some-license-inactive-assign'" [hideConfirm]="true" (confirm)="show($event)"
  [head]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP'" [head5]="'('+licenseInactiveData+')'"
  [extendedMessage]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_EXTENDED'" [message]="'COMMON.EMPTY_STRING'"
  [cancelText]="'COMMON.UNDERSTAND'"></hbo-confirmation-modal>

<hbo-confirmation-modal [id]="'admin-some-license-assign'" [hideConfirm]="true"
  (confirm)="backConfirmReassignPackageModal($event)" [head]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP'"
  [message]="licenseWarningNoDevice ? 'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_ADMIN_NO_DEVICE' : 'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_ADMIN'"
  [cancelText]="'COMMON.UNDERSTAND'"></hbo-confirmation-modal>